<div class="flex gap-2 justify-end pr-[0.25em]">
  <app-pan-button
    color="info"
    icon="visibility"
    matTooltip="Findings Summary"
    fill="outline"
    (click)="params.findingsCallback(params.data)"
  ></app-pan-button>

  <a panButton [routerLink]="['/shared', 'investigation', params.data.review_id]" target="_blank" color="info" icon="open_in_new" matTooltip="View Details" data-testid="view-details-button"></a>
</div>
